(function () {
  'use strict';

  angular.module('app.pathAdvisor', [
  ]);
})();
